import dayjs from "dayjs";

export const isEndingWithin24Hours = (time: Date) => {
  return dayjs(time).isAfter(dayjs()) && dayjs(time).isBefore(dayjs().add(1, "day"));
};
